import React from 'react';
import Morelist from '../components/More/Morelist';
import { useNavigate, useParams } from 'react-router-dom';
function More() {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/`);  // Navigate with query param & path, query, key=value pair
  };
  return (
    <div className="page-container"> {/* Use className */} 
      <h2 className="poems__title_painting"><span><a href="#" onClick={(e) => handleClick()}><img src={require('../assets/images/back.png')} style={{ width: 25 }} /></a></span>More</h2>
      <Morelist />
    </div>
  );

}

export default More;